import { memo, useCallback, useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { DividerSeparator } from '@lyearn/ui';
import { DividerProps } from '@lyearn/ui';
import { Modal } from '@/components/Modals';
import getModifiedAttempts from '@/modules/corporate/modules/quiz/views/QuizDetails/utils/getQuizModifiedAttempts';

import { quizReviewContainerStyles } from '../../../QuizPlayer/components/Body/styles';
import QuizPlayerReview from '../../../QuizPlayer/views/QuizPlayerReview';
import { getCanRetakeQuiz } from '../../utils/getCanRetakeQuiz';
import QuizHeader from '../QuizDetailsQuizPlayer/components/QuizPlayerHeader/components/QuizHeader';
import QuizPlayerDialog from '../QuizPlayerDialog';
import AttemptHistoryItem from './components/AttemptHistoryItem';
import { modalPaperStyles } from './styles';
import { AttemptHistoryProps } from './types';

const DIVIDER_PROPS: DividerProps = {
  className: 'bg-divider',
};

const MODAL_CLASSES = {
  paper: modalPaperStyles,
};

const AttemptHistory: React.FC<AttemptHistoryProps> = (props) => {
  const {
    isEmbed,
    content,
    onClose,
    parentEntityId,
    quizPerformance,
    learnerId,
    isLocalizedContent,
  } = props;
  const { t } = useTranslation();

  const attemptsHistory = getModifiedAttempts(quizPerformance);

  const [selectedAttemptHistoryId, setSelectedAttemptHistoryId] = useState('');

  const renderHistory = useCallback(
    () => (
      <DividerSeparator className="flex-1 px-24 pb-24" direction="col" dividerProps={DIVIDER_PROPS}>
        {attemptsHistory.map((attempt, index) => {
          const quizMaxScore = attempt?.maxScore ?? content?.maxScore;
          return (
            <AttemptHistoryItem
              key={attempt.attemptId}
              attempt={attempt}
              index={attemptsHistory.length - 1 - index}
              maxScore={quizMaxScore}
              onClick={() => setSelectedAttemptHistoryId(attempt.attemptId)}
            />
          );
        })}
      </DividerSeparator>
    ),
    [attemptsHistory, content?.maxScore],
  );

  const { cannotRetakeSincePassed } = getCanRetakeQuiz(content, quizPerformance);

  return (
    <>
      <Modal
        classes={MODAL_CLASSES}
        header={{
          title: t('QuizPlayer:AttemptHistory'),
          description: cannotRetakeSincePassed
            ? t('QuizPlayer:AttemptHistoryPassedDescription')
            : t('QuizPlayer:AttemptHistoryDescription'),
        }}
        onClose={onClose}>
        {renderHistory()}
      </Modal>
      {selectedAttemptHistoryId ? (
        <QuizPlayerDialog>
          <QuizPlayerReview
            attemptId={selectedAttemptHistoryId}
            className={quizReviewContainerStyles(isEmbed)}
            contentId={content.id}
            isEmbed={isEmbed}
            isLocalizedContent={isLocalizedContent}
            parentEntityId={parentEntityId}
            renderHeader={(quiz) => (
              <QuizHeader
                label={quiz.name}
                quizId={quiz.id}
                quizPerformance={quizPerformance}
                onClose={onClose}
              />
            )}
            userId={learnerId}
          />
        </QuizPlayerDialog>
      ) : null}
    </>
  );
};

export default memo(AttemptHistory);
